"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var PopperContext_1 = require("./PopperContext");
var usePopperReference = function () {
    var referenceRef = react_1.useRef(null);
    var setReferenceElement = PopperContext_1.usePopperContext().setReferenceElement;
    react_1.useEffect(function () {
        setReferenceElement(referenceRef.current);
    }, [referenceRef, setReferenceElement]);
    return { ref: referenceRef };
};
exports.default = usePopperReference;
